<div class="h-full w-full flex flex-col bg-gray-50 relative overflow-auto">

  <div
    class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] rounded-b-[30px] shadow-sm pt-4 px-4 pb-12 relative z-10 flex flex-col items-center">

    <div
      class="absolute left-4 top-4 w-[40px] h-[40px] bg-white rounded-full shadow-md flex justify-center items-center cursor-pointer active:scale-95 transition-transform"
      (click)="goback()">
      <img src="icons/Payment/back-payment.png" alt="back" class="w-[20px] h-[20px]" />
    </div>

    <div class="mt-8 mb-2 flex flex-col items-center animate-slide-up">
      <div
        class="w-20 h-20 p-4 bg-white/40 rounded-full flex items-center justify-center mb-4 shadow-sm backdrop-blur-sm border-2 border-(--main-color)">
        <img src="icons/alt_route_orange.svg" class="w-full h-full" />
      </div>
      <h1 class="text-xl font-bold text-(--main-color) text-center">
        {{ currentLang === "TH" ? "เลือกรายการ" : "Select Option"}}
      </h1>
      <p class="text-sm text-(--main-color) mt-1 text-center max-w-[250px]">
        {{ currentLang === "TH" ? "กรุณาเลือกทำรายการที่ต้องการ" : "Please select the transaction you want to perform"}}
      </p>
    </div>
  </div>

  <div class="flex-1 px-6 -mt-6 z-20 space-y-4 pb-10">
    <button (click)="goToRegister()"
      class="w-full bg-white rounded-2xl p-5 shadow-sm border border-gray-100 flex items-center gap-4 transition-all duration-300 hover:shadow-md active:scale-[0.98] group relative overflow-hidden">
      <div class="absolute left-0 top-0 bottom-0 w-1.5 bg-(--main-color) group-hover:w-2 transition-all"></div>

      <div
        class="w-14 h-14 bg-(--main-color)/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-(--main-color)/20 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-(--main-color)" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125c0 .621.504 1.125 1.125 1.125H18.75A1.125 1.125 0 0119.875 18H4.125a1.125 1.125 0 01-1.125-1.125V6.75a1.125 1.125 0 011.125-1.125H6.75a2.25 2.25 0 002.25 2.25H10.5a2.25 2.25 0 002.25-2.25h1.5c.621 0 1.125.504 1.125 1.125z" />
        </svg>
      </div>

      <div class="flex-1 text-left">
        <h3 class="text-md font-bold text-(--sub-color) group-hover:text-(--main-color) transition-colors">
          {{ currentLang === "TH" ? "สมัครสมาชิกใหม่" : "New Registration"}}
        </h3>
        <p class="text-sm text-gray-400 font-medium mt-0.5">
          {{ currentLang === "TH" ? "สำหรับผู้ใช้ใหม่" : "For new users"}}
        </p>
      </div>

      <div class="text-gray-300 group-hover:text-(--main-color) transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </button>

    <button (click)="goToRenew()"
      class="w-full bg-white rounded-2xl p-5 shadow-sm border border-gray-100 flex items-center gap-4 transition-all duration-300 hover:shadow-md active:scale-[0.98] group relative overflow-hidden">
      <div class="absolute left-0 top-0 bottom-0 w-1.5 bg-(--main-color) group-hover:w-2 transition-all"></div>

      <div
        class="w-14 h-14 bg-(--main-color)/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-(--main-color)/20 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-(--main-color)" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      </div>

      <div class="flex-1 text-left">
        <h3 class="text-md font-bold text-(--sub-color) group-hover:text-(--main-color) transition-colors">
          {{ currentLang === "TH" ? "ต่ออายุสมาชิก" : "Renew Membership"}}
        </h3>
        <p class="text-sm text-gray-400 font-medium mt-0.5">
          {{ currentLang === "TH" ? "สำหรับสมาชิกเดิม" : "For existing members"}}
        </p>
      </div>

      <div class="text-gray-300 group-hover:text-(--main-color) transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </button>



  </div>

  <div class="absolute bottom-8 left-0 w-full flex justify-center opacity-20 pointer-events-none z-0">
    <img src="icons/PSS/PSS Sticker-01.png" class="w-48 h-auto grayscale opacity-50">
  </div>

</div>